import { Button, ButtonProps } from "antd";
import styled, { css } from "styled-components";

interface ButtonStyledProps extends ButtonProps {
  tooltip?: boolean;
  color?: string;
}

export const ButtonStyled = styled(Button)<ButtonStyledProps>`
  font-size: ${(isMobile) => (isMobile ? "14px" : "")};
  &.ant-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    column-gap: 8px;
    box-shadow: none !important;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 500;
  }
  
  &[disabled] {
    border-color: var(--veloprime-text-secondary) !important;
    color: var(--veloprime-text-secondary) !important;
    background-color: var(--light-gray) !important;

    &:hover {
      background-color: var(--ghost) !important;
    }
  }
  
  ${({ tooltip }) =>
    tooltip &&
    css`
      border-color: var(--veloprime-text-secondary) !important;
      color: var(--veloprime-text-secondary) !important;
      background-color: var(--veloprime-bg-alternative) !important;
    `}
  
  ${({ type, color }) =>
    type === "primary" &&
    css`
      background-color: var(--veloprime-soft-gold) !important;
      border-color: var(--veloprime-soft-gold) !important;
      color: ${color || "var(--veloprime-text-primary)"} !important;
      
      &:hover {
        background-color: #c49a7a !important;
        border-color: var(--veloprime-soft-gold) !important;
      }
      
      svg {
        fill: var(--veloprime-deep-navy);
      }
    `}
  
  ${({ size }) =>
    size === "large" &&
    css`
      height: 56px;
      padding: 0 24px;
      font-size: 16px;
      
      svg {
        width: 18px;
        height: 18px;
        min-width: 18px;
        min-height: 18px;
        max-width: 18px;
        max-height: 18px;
      }
    `}
    
  ${({ disabled }) =>
    disabled &&
    css`
      svg {
        fill: var(--veloprime-text-secondary) !important;
      }
    `}
`;
